
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const useWeeklyResetMutation = () => {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (): Promise<{totalCoins: number, resetCount: number}> => {
      // Get the current weekly balance
      const { data: balanceData, error: balanceError } = await supabase
        .from('weekly_balances')
        .select('amount')
        .order('created_at', { ascending: false })
        .limit(1)
        .maybeSingle();

      if (balanceError) throw balanceError;
      
      const totalCoins = balanceData?.amount || 0;
      
      // Reset all completed tasks to incomplete
      const { data: resetData, error: resetError } = await supabase
        .from('tasks')
        .update({ is_completed: false })
        .eq('is_completed', true)
        .select();

      if (resetError) throw resetError;
      
      // Reset the weekly balance to 0
      const { error: resetBalanceError } = await supabase
        .from('weekly_balances')
        .insert([{ amount: 0 }]);

      if (resetBalanceError) throw resetBalanceError;
      
      return {
        totalCoins,
        resetCount: resetData?.length || 0
      };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tasks'] });
    },
    onError: (error) => {
      console.error('Error performing weekly reset:', error);
      toast({
        title: "Error",
        description: "Failed to perform weekly reset. Please try again.",
        variant: "destructive",
      });
    }
  });
};
